import { Component, Input } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';


const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<ion-list radio-group [(ngModel)]="variableValue.value" (ionChange)="onChangeCallback()" *ngFor="let option of variable.options">
    <ion-item class="radio-item">
        <ion-label>{{option.label}}</ion-label>
        <ion-radio value="{{option.variableValue.value}}"></ion-radio>
    </ion-item>
</ion-list>
`;

const CSS_STYLE = `
.radio-item {
    min-height: 36px;
    height: 36px;
}

.var-title {
    padding-bottom: 8px;
}

.list-md {
    margin: -1px 0 -8px !important
}
`;

@Component({
    selector: 'variable-radio',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableRadioComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "",
            value: ""
        }
    }

    ngOnInit() {
        this.setValue(this.variable.defaultValue)
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue): void {
        if (variableValue){
            this.variableValue = {
                asBoolean: (variableValue.value ? true : false),
                asString:  String(variableValue.value),
                value:  variableValue.value
            }
        }       
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.setValue(this.variableValue);

        this.callback(this);
    }

    public getLegendClass(): string {
        return "";
    }
}
